import { render, staticRenderFns } from "./teachingResult.vue?vue&type=template&id=5ede7172&"
import script from "./teachingResult.vue?vue&type=script&lang=js&"
export * from "./teachingResult.vue?vue&type=script&lang=js&"
import style0 from "./teachingResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports